// assets
import {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconReceipt,
  IconNews,
  IconPackageExport
} from '@tabler/icons-react';

// constant
const icons = { IconDashboard, IconSitemap, IconArticle, IconCoin, IconAdjustments, IconKey, IconGardenCart, IconUser, IconUserScan, IconReceipt, IconNews, IconPackageExport };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'menu.dashboard',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'channel',
      title: 'menu.channel',
      type: 'item',
      url: '/panel/channel',
      icon: icons.IconSitemap,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'token',
      title: 'menu.token',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconKey,
      breadcrumbs: false
    },
    {
      id: 'log',
      title: 'menu.log',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false
    },
    {
      id: 'redemption',
      title: 'menu.redemption',
      type: 'item',
      url: '/panel/redemption',
      icon: icons.IconCoin,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'topup',
      title: 'menu.topup',
      type: 'item',
      url: '/panel/topup',
      icon: icons.IconGardenCart,
      breadcrumbs: false
    },
    {
      id: 'user',
      title: 'menu.user',
      type: 'item',
      url: '/panel/user',
      icon: icons.IconUser,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'news',
      title: 'menu.news',
      type: 'item',
      url: '/panel/news',
      icon: icons.IconNews,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'ucodex-release',
      title: 'menu.ucodexRelease',
      type: 'item',
      url: '/panel/ucodex-release',
      icon: icons.IconPackageExport,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'profile',
      title: 'menu.profile',
      type: 'item',
      url: '/panel/profile',
      icon: icons.IconUserScan,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'kyc',
      title: 'menu.kyc',
      type: 'item',
      url: '/panel/kyc',
      icon: icons.IconReceipt,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'kyc-management',
      title: 'menu.kycManagement',
      type: 'item',
      url: '/panel/kyc-management',
      icon: icons.IconUserScan,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'setting',
      title: 'menu.setting',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      isAdmin: true
    }
  ]
};

export default panel;
